import { useReduxState } from 'hooks';
import { AnalyticsDataWithChart } from 'components/analytics';
import { Icon } from 'components/common/icons';

interface Props {
  chartId: string;
  completionEnabled: boolean;
  numberOfCompleted: number;
  numberOfCompletionExpired: number;
  numberOfCompletionExpiring: number;
  numberOfParticipants: number;
  numberOfNotStarted: number;
  numberOfStarted: number;
  participantsLabel: string;
  participantsLabelDescription: string;
}

const CourseParticipantsChart = ({
  chartId,
  completionEnabled,
  numberOfCompleted,
  numberOfCompletionExpired,
  numberOfCompletionExpiring,
  numberOfParticipants,
  numberOfNotStarted,
  numberOfStarted,
  participantsLabel,
  participantsLabelDescription
}: Props) => {
  const { messages, theme } = useReduxState();

  return (
    <div className="chart">
      <AnalyticsDataWithChart
        chartData={[
          ...(completionEnabled
            ? [
                {
                  name: messages.tasksUsersCompletedSingular,
                  value: numberOfCompleted,
                  tooltipValue:
                    numberOfCompleted +
                    ` (${Math.round(
                      (numberOfCompleted / numberOfParticipants) * 100
                    )}%)`,
                  color: theme.successStandaloneColor
                },
                ...(numberOfCompletionExpiring
                  ? [
                      {
                        name: messages.completionsExpiring,
                        value: numberOfCompletionExpiring,
                        tooltipValue:
                          numberOfCompletionExpiring +
                          ` (${Math.round(
                            (numberOfCompletionExpiring /
                              numberOfParticipants) *
                              100
                          )}%)`,
                        color: theme.warningColor
                      }
                    ]
                  : []),
                ...(numberOfCompletionExpired
                  ? [
                      {
                        name: messages.completionsExpired,
                        value: numberOfCompletionExpired,
                        tooltipValue:
                          numberOfCompletionExpired +
                          ` (${Math.round(
                            (numberOfCompletionExpired / numberOfParticipants) *
                              100
                          )}%)`,
                        color: theme.dangerColor
                      }
                    ]
                  : [])
              ]
            : []),
          {
            name: messages.tasksUsersStartedSingular,
            value: numberOfStarted,
            tooltipValue:
              numberOfStarted +
              ` (${Math.round(
                (numberOfStarted / numberOfParticipants) * 100
              )}%)`,
            color: 'rgba(0, 0, 0, 0.4)'
          },
          {
            name: messages.tasksUsersNotStartedSingular,
            value: numberOfNotStarted,
            tooltipValue:
              numberOfNotStarted +
              ` (${Math.round(
                (numberOfNotStarted / numberOfParticipants) * 100
              )}%)`,
            color: theme.lightGrey
          }
        ]}
        chartEmptyTooltip={messages.commonNoParticipants}
        chartId={chartId}
        chartLabel={
          numberOfParticipants
            ? `${Math.round((numberOfCompleted / numberOfParticipants) * 100)}%`
            : '–'
        }
        statsPrimaryItem={{
          label: (
            <span
              aria-label={participantsLabelDescription}
              data-tooltip={participantsLabelDescription}
            >
              {participantsLabel}
              <Icon
                icon="question-circle"
                style={{ fontSize: '1.2rem', marginLeft: 5 }}
              />
            </span>
          ),
          value: numberOfParticipants
        }}
        statsSecondaryItems={[
          completionEnabled
            ? {
                label: messages.tasksUsersCompletedSingular,
                value: numberOfCompleted
              }
            : {
                label: messages.tasksUsersStartedSingular,
                value: numberOfStarted
              }
        ]}
      />
    </div>
  );
};

export default CourseParticipantsChart;
